import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { PatientProcedureDayType } from "../../../core/enums/PatientProcedureDayType";
import { PatientProcedureDayDTO } from "src/DTOs/PatientProcedures/Models/PatientProcedureDayDTO";
import { PatientProcedureDaysDetailDTO } from "src/DTOs/PatientProcedures/Models/PatientProcedureDaysDetailDTO";
import { MessageStatus } from "src/core/enums/MessageStatus";
import { CompareDto } from "src/DTOs/Cases/Models/Compare/CompareDto";
import { PatientProceduresService } from "src/patient-procedures/patient-procedures.service";
import { CasesService } from "src/cases/cases.service";
import { OrgSettingsService } from "../../../org-settings/org-settings.service";
import { ExcludeQuestionAnswersDTO } from "src/DTOs/PatientProcedures/Models/ExcludeQuestionAnswersDTO";
import { AuthService } from "../../../auth/auth.service";
import { UserProfile } from "../../../models/userprofile";

@Component({
  selector: "survey-results-seemore-dialog",
  templateUrl: "./survey-results-seemore-dialog.html",
  styleUrls: ["./survey-results-seemore-dialog.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SurveyResultsSeeMoreDialog implements OnInit {
  public MessageType: string = "";
  public procedureDays: PatientProcedureDaysDetailDTO[];
  
  public excludeQuestionAnswersDTO:ExcludeQuestionAnswersDTO;

  public ProcedureDayMessageStatusScheduled = MessageStatus.Value("scheduled");
  public ProcedureDayMessageStatusResponded = MessageStatus.Value(
    "surveyresponded"
  );
  public ProcedureDayMessageStatusSent = MessageStatus.Value("sent");
  public ProcedureDayMessageStatusDeliveredByProvider = MessageStatus.Value(
    "deliveredbyprovider"
  );
  public ProcedureDayMessageStatusError = MessageStatus.Value("error");
  public ProcedureDayMessageStatusHalted = MessageStatus.Value("halted");

  public selectedTabIndex: number;

  public compareData: CompareDto = CompareDto.Empty();

  public questionGroups: any[];
  selectedExcludedSurveys: any[] = [];
  fetchedExcludedQuestionAnswers: ExcludeQuestionAnswersDTO[] = [];
  CenterId:string = "";
  public userProfile: UserProfile;
  public OrgId = "";
  public orgsAllowedToExcludedQuestionAnswers:string[]=[];
  public readonly OrganizationManagerRoleId = "00000000-0000-0000-0000-000000000003";

  ngOnInit(): void {

    this.authService.getClaims$().subscribe((claims: UserProfile) => {
      this.userProfile = claims;
      this.OrgId = this.userProfile.organization_id;
    });

    this.MessageType = PatientProcedureDayType.Name(
    this.data.selectedProcDays.ProcedureDayType
    );
    this.CenterId = this.data.selectedProcDays.find(item => item.CenterID !== undefined).CenterID;
    this.orgSettingService.getExcludedQuestionAnswers(this.CenterId)
    .subscribe(
      (response) => {
        this.fetchedExcludedQuestionAnswers = response;
        for (let i = 0; i < this.procedureDays.length; i++) {
          const item = this.procedureDays[i];
          if (item.SurveyQuestionAnwers !== null&& item.SurveyQuestionAnwers !== undefined) {
            for (let j = 0; j < item.SurveyQuestionAnwers.length; j++) {
              const answer = item.SurveyQuestionAnwers[j];
              const isExcluded = this.fetchedExcludedQuestionAnswers.some(dto => dto.questionAnswerId === answer.QuestionID);
              answer.IsExcluded = isExcluded;
              const index = this.selectedExcludedSurveys.indexOf(answer);
            }
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );

    for (let i = 0; i < this.procedureDays.length; i++) {
      if (
        this.procedureDays[i].ProcedureDayID === this.data.selectedProcedureId
      ) {
        this.selectedTabIndex = i;

        break;
      }
    }

    this.appointmentService
      .getSurveyResultsGroupedByQuestions(this.data.procedureId)
      .subscribe(
        (response) => {
          this.compareData = response;
          if (response !== undefined) {
            this.createQuestionGroups();
          }
        },
        (error) => {
          console.error(error);
        }
      );
  } //ngOnInit

  constructor(
    public dialogRef: MatDialogRef<SurveyResultsSeeMoreDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appointmentService: PatientProceduresService,
    private caseservice: CasesService,
    private orgSettingService: OrgSettingsService,
    private authService: AuthService,
  ) {
    console.log(this.data, "data");

    this.procedureDays = data.selectedProcDays;
    this.excludeQuestionAnswersDTO = {
      questionAnswerId: null,
      centerId: null
    };

    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getEventTime(dt1: Date, dt2: Date): Date {
    if (dt1 == null) {
      return dt2;
    } else {
      return dt1;
    }
  }

  messageType(messageTypeId: number): string {
    return PatientProcedureDayType.Name(messageTypeId);
  }

  procedureStatus(procedureStatusId: number): string {
    return MessageStatus.Name(procedureStatusId);
  }

  createQuestionGroups(): void {
    const resultArray = this.compareData.messageStatuses.map((ms) => {
      return {
        procedureDayId: ms.procedureDayId,
        answer: "NotAnswered",
      };
    });
    this.questionGroups = this.compareData.compareQuestionGroups.map((qg) => {
      let days = JSON.parse(JSON.stringify(resultArray));

      for (let i = 0; i < days.length; i++) {
        for (let j = 0; j < qg.questionAnswers.length; j++) {
          if (days[i].procedureDayId === qg.questionAnswers[j].procedureDayId) {
            days[i].answer = qg.questionAnswers[j].questionResponse;

            break;
          }
        }
      }

      return {
        displayName: qg.displayName,
        answers: days,
      };
    });
  }

  openFile(fileName: string, event) {
    event.preventDefault();

    this.caseservice.getBlobUrl(fileName).subscribe(
      (response) => {
        window.open(response.fileUrl, "_blank");
      },
      (error) => {
        console.error(error);
      }
    );
  }

  removeExcludedQuestion(excludeQuestionAnswersDTOList: ExcludeQuestionAnswersDTO[]){
    this.orgSettingService.removeExcludedQuestionAnswers(excludeQuestionAnswersDTOList)
      .subscribe(
        (response) => {
          this.dialogRef.close();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  saveExcludedQuestion(excludeQuestionAnswersDTOList: ExcludeQuestionAnswersDTO[]){
    this.orgSettingService.saveExcludedQuestionAnswers(excludeQuestionAnswersDTOList)
      .subscribe(
        (response) => {
          this.dialogRef.close();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getExcludedQuestion(centerId: string){
    this.orgSettingService.getExcludedQuestionAnswers(centerId)
      .subscribe(
        (response) => {
          this.fetchedExcludedQuestionAnswers = response;
        },
        (error) => {
          console.error(error);
        }
      );
  }

  toggleExcludedQuestion(survey: any) {
    const index = this.selectedExcludedSurveys.indexOf(survey);
    if (index === -1) {
      // Add to selectedExcludedSurveys if checkbox is checked
      this.selectedExcludedSurveys.push(survey);
    } 
    else if (index !== -1){
      const isTheSame = this.selectedExcludedSurveys.some(dto => dto.QuestionID === survey.QuestionID && dto.IsExcluded === survey.IsExcluded);
      if(isTheSame){
        this.selectedExcludedSurveys.splice(index, 1);
      } 
      // Remove from selectedExcludedSurveys if checkbox is unchecked
    }
    this.isButtonDisabled();
  }

  saveOrRemoveExcludedQuestions(CenterID: string) {
    const surveysToAdd: ExcludeQuestionAnswersDTO[] = [];
    const surveysToRemove: ExcludeQuestionAnswersDTO[] = [];
    for (const survey of this.selectedExcludedSurveys) {

      const excludeQuestionAnswersDTO: ExcludeQuestionAnswersDTO = {
        questionAnswerId: survey.QuestionID,
        centerId: CenterID,
        // Add other properties as needed
      }

      if (survey.IsExcluded) {
        surveysToAdd.push(excludeQuestionAnswersDTO);
        console.log('Survey marked as excluded:', survey);
        // Call saveExcludedQuestion here
      } else {
        surveysToRemove.push(excludeQuestionAnswersDTO);
        console.log('Survey removed from excluded:', survey);
        // Call removeExcludedQuestion here
      }
    }

    if (surveysToAdd.length > 0) {
      this.saveExcludedQuestion(surveysToAdd);
    }
  
    // Make a single call to remove surveys
    if (surveysToRemove.length > 0) {
      this.removeExcludedQuestion(surveysToRemove);
    }

    // Clear the selected surveys array for the next selection
    this.selectedExcludedSurveys = [];
    this.isButtonDisabled();
  }
  hasPermissionToExclude(): boolean {
    let hasPermission: boolean = false;
      if (this.authService.isAdmin() || this.authService.isOrgManager() ){
        hasPermission = true;
      }
    return hasPermission;
  }

  isButtonDisabled(): boolean {
    let hasPermission: boolean = true;
    if (this.selectedExcludedSurveys.length > 0) {
      hasPermission = false;
    }
    return  hasPermission;
  }
}
